import { render } from "./ProductInventorySpecificForm.vue?vue&type=template&id=738f3a13&ts=true"
import script from "./ProductInventorySpecificForm.vue?vue&type=script&lang=ts"
export * from "./ProductInventorySpecificForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__